import { Component, OnInit } from '@angular/core';
import { NgbDateAdapter, NgbDateNativeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { PurchaseOrderService } from 'src/app/services/purchase-order.service';

@Component({
  selector: 'app-purchase-order-sap-report',
  templateUrl: './purchase-order-sap-report.component.html',
  styleUrls: ['./purchase-order-sap-report.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}]
})
export class PurchaseOrderSapReportComponent implements OnInit {

  loading:boolean = false;

  date1:Date = new Date();
  date2:Date = new Date();

  lineTotal:number = 0;

  data = [];

  constructor(private purchaseServ:PurchaseOrderService) { }

  ngOnInit() {
  }
  search(){
    this.loading = true;
    this.lineTotal = 0;
    this.purchaseServ.getReport(this.date1, this.date2, null, null, true).then(resp=>{
      this.data = resp;
      this.lineTotal = this.data.map(da=> Number(da.LineTotal)).reduce((an, ac)=> ac + an, 0);
      this.loading = false;
    });
  }

}
